import { render, staticRenderFns } from "./Hotzone.vue?vue&type=template&id=2827a37d&"
import script from "./Hotzone.vue?vue&type=script&lang=js&"
export * from "./Hotzone.vue?vue&type=script&lang=js&"
import style0 from "./Hotzone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Hotzone.vue"
export default component.exports